const drawer = {
  MuiDrawer: {
    styleOverrides: {
      root: {
        '.MuiPaper-root': {
          minWidth: '70vw',
          borderRadius: '7px 0 0 7px',
        },

        '.MuiPaper-root, .MuiPaper-root ul': {
          padding: 0,
        },
      },
    },
  },
};

export default drawer;
